// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__ndmA-","button":"navbar_button__IO2FC"};